import React, { useCallback } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import Logo from '../elements/logo.element';
import FormModal from '../modals/form.modal';
import RegisterForm from '../forms/registration.form';
import LoginForm from '../forms/login.form';
import UserMenu from '../elements/user-menu.element';
import useNavigateHook from '../../hooks/navigate.hook';

const Header: React.FC = () => {
  const { isAuthenticated } = useSelector((state: any) => state.auth);
  const { doNavigate } = useNavigateHook();

  const [showRegistrationFormModal, setShowRegistrationFormModal] = React.useState(false);
  const [showLoginFormModal, setShowLoginFormModal] = React.useState(false);

  const openRegistrationFormModal = () => {
    setShowLoginFormModal(false);
    setShowRegistrationFormModal(true);
  };

  const openLoginFormModal = () => {
    setShowRegistrationFormModal(false);
    setShowLoginFormModal(true);
  };

  const onRegistrationSuccess = () => {
    setShowRegistrationFormModal(false);
  };

  const onLoginSuccess = () => {
    setShowLoginFormModal(false);
  };

  const navigateTo = useCallback(
    (path: string) => {
      doNavigate(path);
    },
    [doNavigate]
  );

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{ bgcolor: '#fff', color: '#000', borderBottom: '1px solid #e0e0e0' }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logo />
            <Typography variant="h6" fontWeight="bold" color="text.primary">
              Scrap Auction
            </Typography>
          </Box>

          {/* Center nav links */}
          <Box sx={{ display: 'flex', gap: 4 }}>
            <Button color="inherit" onClick={() => navigateTo('/')}>
              Home
            </Button>
            <Button color="inherit" onClick={() => navigateTo('/auctions.html')}>
              Auctions
            </Button>
            <Button color="inherit" onClick={() => navigateTo('/scrape-items.html')}>
              Items
            </Button>
            <Button color="inherit" onClick={() => navigateTo('/about.html')}>
              About
            </Button>
            <Button color="inherit" onClick={() => navigateTo('/how-it-works.html')}>
              How It Works
            </Button>
          </Box>

          {/* Right side actions */}
          {isAuthenticated ? (
            <UserMenu />
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button color="inherit" onClick={openLoginFormModal}>
                Login
              </Button>
              <Button variant="contained" color="primary" onClick={openRegistrationFormModal}>
                Register
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      {showRegistrationFormModal && (
        <FormModal
          open={showRegistrationFormModal}
          onClose={() => setShowRegistrationFormModal(false)}
          size="xs"
        >
          <RegisterForm onSuccess={onRegistrationSuccess} loginCallback={openLoginFormModal} />
        </FormModal>
      )}
      {showLoginFormModal && (
        <FormModal open={showLoginFormModal} onClose={() => setShowLoginFormModal(false)} size="xs">
          <LoginForm onSuccess={onLoginSuccess} registerCallback={openRegistrationFormModal} />
        </FormModal>
      )}
    </>
  );
};

export default Header;
